module.exports = __webpack_public_path__ + "static/media/RIGHT-DECORATION.1b8312c6.svg";